export const Actions = {
  CHECK_UNGROUP: 'CHECK_UNGROUP',
};
export const checkForUngroup = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.CHECK_UNGROUP,
    payload,
  });
};
